export default import.meta.ROLLDOWN_FILE_URL_Y1zMiY0wPdKzmdmhicIokg